/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link } from "react-router-dom";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";

const HeroSlideWithForeground = (props) => {

    const foregroundImageSrc = props?.foregroundImageSrc ?? "";
    const foregroundImageAlt = props?.foregroundImageAlt ?? "";
    const title = props?.title ?? "";
    const subtitle = props?.subtitle ?? "";
    const description = props?.description ?? "";
    const linkText = props?.linkText ?? "";
    const scrollToSection = props?.scrollToSection;

    return (
        <div className='hero-content'>
            <div className='hero-content-left'>
                <div className='hero-content-left-text'>
                    <h1>
                        {title}
                        {subtitle && <span>{` ${subtitle}`}</span>}
                    </h1>

                    <RichTextSimple
                        richtext={description}
                        className='hero-slide-description'
                    />
                </div>

                <Link onClick={scrollToSection} className='hero-slide-link'>
                    {linkText}
                </Link>
            </div>
            <div className='hero-content-right'>
                <img src={foregroundImageSrc} alt={foregroundImageAlt} />
            </div>
        </div>
    );
};

export { HeroSlideWithForeground };
